//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Tooltip from '@nextcloud/vue/dist/Directives/Tooltip';
import Avatar from '@nextcloud/vue/dist/Components/Avatar';
export default {
  name: 'GuestNameDialog',
  components: {
    Avatar: Avatar
  },
  directives: {
    tooltip: Tooltip
  },
  props: {
    syncService: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      guestName: '',
      guestNameBuffered: ''
    };
  },
  computed: {
    avatarUrl: function avatarUrl() {
      var size = 32;
      var avatarUrl = OC.generateUrl('/avatar/guest/{user}/{size}', {
        user: this.guestNameBuffered,
        size: size
      });
      return window.location.protocol + '//' + window.location.host + avatarUrl;
    }
  },
  beforeMount: function beforeMount() {
    this.guestName = this.syncService.session.guestName;
    this.updateBufferedGuestName();
  },
  methods: {
    setGuestName: function setGuestName() {
      var _this = this;

      var previousGuestName = this.syncService.session.guestName;
      this.syncService.updateSession(this.guestName).then(function () {
        localStorage.setItem('nick', _this.guestName);

        _this.updateBufferedGuestName();
      }).catch(function (e) {
        _this.guestName = previousGuestName;
      });
    },
    updateBufferedGuestName: function updateBufferedGuestName() {
      this.guestNameBuffered = this.guestName;
    }
  }
};